import { BlockFileEntry } from "./formValuesToAnnouncement";

function buildAnnouncementFormData(
	data: Partial<MeeAnnouncement>,
	imageFile: File | null,
	imageRemoved: boolean,
	blockFiles: BlockFileEntry[] = []
): FormData {
	const formData = new FormData();
	formData.append("title", data.title ?? "");
	formData.append("body", data.body ?? "");
	formData.append("push_title", data.pushTitle ?? "");
	formData.append("push_body", data.pushBody ?? "");
	formData.append("audience_type", data.audienceType ?? "everyone");
	formData.append("audience_platform", data.audiencePlatform ?? "");
	formData.append(
		"audience_user_ids",
		JSON.stringify(data.audienceUserIds ?? [])
	);
	formData.append("scheduled_at", data.scheduledAt ?? "");
	formData.append("expires_at", data.expiresAt ?? "");

	formData.append("content_blocks", JSON.stringify(data.contentBlocks ?? []));

	if (imageFile) {
		formData.append("hero_image", imageFile);
	} else if (imageRemoved) {
		formData.append("hero_image", "");
	}

	for (const { index, file } of blockFiles) {
		formData.append(`content_block_file_${index}`, file);
	}

	return formData;
}

export const adaptCreateAnnouncementPayload = (
	data: Partial<MeeAnnouncement>,
	imageFile: File | null,
	blockFiles: BlockFileEntry[] = []
): FormData => {
	return buildAnnouncementFormData(data, imageFile, false, blockFiles);
};

export const adaptEditAnnouncementPayload = (
	data: Partial<MeeAnnouncement>,
	imageFile: File | null,
	imageRemoved = false,
	blockFiles: BlockFileEntry[] = []
): FormData => {
	return buildAnnouncementFormData(data, imageFile, imageRemoved, blockFiles);
};
